import { createContext, ReactNode, useContext } from 'react';

export type ButtonStateProps = {
	setState: (o: string) => void;
	state: string;
};

type ProviderType = {
	children: ReactNode;
	state: string;
	setState: (o: string) => void;
};

const ButtonState = createContext<ButtonStateProps>({ state: 'default' } as any);

const provideButtonState = (state: string, setState: (o: string) => void) => {
	return {
		state,
		setState,
	};
};

const ButtonStateProvider = ({ children, ...rest }: ProviderType) => {
	const value = provideButtonState(rest.state, rest.setState);
	return <ButtonState.Provider value={value}>{children}</ButtonState.Provider>;
};

export const useButtonState = () => useContext(ButtonState);

export default ButtonStateProvider;
